import React, { useContext } from 'react'
import './style/Q3.css'
import Headling from '../Headling'
import Subtitle from '../Subtitle'
import YesOrNoQuestion from '../YesOrNoQuestion'
import { setNewAnswer } from '../../Store'
import { useHistory } from 'react-router-dom'
import StepCounter from '../StepCounter'
import gif7 from './assets/10_briefcase 2.gif'
import jpg7 from './assets/static/10_briefcase-2.jpg'

import '../Gif.css'
import ReactPixel from 'react-facebook-pixel';
import { AppContext} from '../../contexts/AppProvider'
import { useLocalize } from 'localize-react';

function Q7() {
    const { settings } = useContext(AppContext)
    const history = useHistory();
    const { translate } = useLocalize()

    return (
        <>
            <div className="picHold hid vis">
                <img className="gif7" src={settings.isAnimationPause ? jpg7 : gif7} />
            </div>
            <Headling text={translate('Smart Investment')} />
            <Subtitle text={translate('Do I have an investment portfolio?')} />
            <YesOrNoQuestion onYesClick={() => {
                setNewAnswer({
                    7: 1,

                })
                history.push('/Q/8')
                ReactPixel.trackCustom('stockmarket_yes', '');
            }}
                onNoClick={() => {
                    setNewAnswer({
                        7: 0
                    })
                    history.push('/Q/10')
                    ReactPixel.trackCustom('stockmarket_no', '');
                }} />
            <StepCounter />
        </>
    )
}



export default Q7

